import React, { Component } from 'react';

export default class StampsItems extends Component {
    render() {
        return (
            <div className="stamps-items">
                <a
                    className="stamp-item"
                    href="https://bluedot.org/certification?id=recXfjOgHQPx7VZbe"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ transform: `rotate(-4deg)` }}
                >
                    <img
                        src="/images/agi-strategy.webp"
                        alt="BlueDot Impact Certificate for AGI Strategy Course"
                    />
                </a>

                <a
                    className="stamp-item"
                    href="https://bluedot.org/certification?id=recXTs5yNxnKCCljH"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ transform: `rotate(3deg)` }}
                >
                    <img
                        src="/images/ai-governance.webp"
                        alt="BlueDot Impact Certificate for Frontier AI Governance Course"
                    />
                </a>

                <a
                    className="stamp-item"
                    href="https://learn.microsoft.com/api/credentials/share/en-us/MaxErler-9916/59F55B91B24B6BF2?sharingId=CD8C2DE2ADCF662C"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ transform: `rotate(7deg)` }}
                >
                    <img
                        src="/images/azure-fundamentals.svg"
                        alt="Azure Fundamentals Course Certificate"
                    />
                </a>

                <a
                    className="stamp-item funny-stamp"
                    href="https://die-kaenguru-chroniken.fandom.com/wiki/Das_Kaenguru_Wiki"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    WITZIG
                </a>

                <a
                    className="stamp-item"
                    href="/documents/INT202506MaErNiyxc - Max Erler.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ transform: `rotate(-6deg)` }}
                >
                    <img
                        src="/images/effective_altruism_introductory_program.svg"
                        alt="Effective Altruism Introductory Program"
                    />
                </a>
            </div>
        );
    }
}
